// extracted by css-extract-rspack-plugin
var _1 = "un2IX";
var _2 = "Kw_BX";
export { _1 as "folderLabel", _2 as "postedToLabel" }
